module.exports = __webpack_public_path__ + "static/media/orcamento-carrefour.be251fd2.png";